import { createApp } from 'vue'
import App from './App.vue'
import AccessGate from './components/AccessGate.vue'
import router from './router'
import i18n from './i18n'
import { loadTimezone } from './utils/timezone'
import { preparePlatformAccess } from './utils/accessGate'
import './styles/asset-flow-theme.css'
import './styles/tech-overrides.css'
import './styles/mobile-shell.css'

document.documentElement.setAttribute('data-theme', 'light')
document.body.setAttribute('data-theme', 'light')

function hideLoadingMask() {
  const loadingMask = document.getElementById('loading-mask')
  if (!loadingMask || loadingMask.style.display === 'none') return
  loadingMask.style.opacity = '0'
  setTimeout(() => {
    loadingMask.style.display = 'none'
  }, 350)
}

async function bootstrap() {
  await loadTimezone()
  const access = await preparePlatformAccess({ forceConfig: true })

  if (!access.granted) {
    const app = createApp(AccessGate, {
      hintZh: access.config?.hintZh || '',
      hintEn: access.config?.hintEn || '',
      onSuccess: () => {
        window.location.reload()
      }
    })
    app.use(i18n)
    app.mount('#app')
    setTimeout(hideLoadingMask, 200)
    return
  }

  const app = createApp(App)
  app.use(router)
  app.use(i18n)
  app.mount('#app')
  setTimeout(hideLoadingMask, 400)
}

bootstrap()

setTimeout(hideLoadingMask, 5000)
